import React from 'react';
import { ATCONSTANTS as ATC } from 'appconstants';
import Select from 'react-select';

function TypeAhead({
  name, value, options, onChange, onChangeText, ariaText, innerRef = null, ...rest
}) {
  let timeoutId;
  const onInputChange = (val) => {
    if (timeoutId != null) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => onChangeText(val), 500);
  };

  return (
    <div className="d-flex row">
      <span className="cssjs-tooltip d-block" style={{ display: 'flex', flex: 1 }} title={`Select ${name}`}>
        <Select
          {...rest}
          className="reactSelect-wrapper"
          data-testid={ariaText}
          aria-label={ariaText}
          aria-labelledby={ariaText}
          classNamePrefix="reactSelect"
          // This style is to show options menu over the popup if Select box is used over the popup
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 1000
            })
          }}
          inputId="react-select-single"
          isClearable
          isValid
          value={value}
          options={options}
          onChange={onChange}
          onInputChange={onInputChange}
          components={{ DropdownIndicator: () => null, IndicatorSeparator: () => null }} // remove drop down arrow
          menuPortalTarget={document.querySelector('body')}
          data-id={`${ATC.PACKETID}${name}${ATC.INPUT}`}
          name={name}
          ref={innerRef}
        />
      </span>
    </div>
  );
}

export default TypeAhead;
